import { useEffect, useRef, useState } from "react";

// só anima se der para saber quando o bloco entra na tela e se o usuário não pediu menos movimento
const canAnimate = () =>
  typeof window !== "undefined" &&
  "IntersectionObserver" in window &&
  !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Devolve a ref do bloco e o sufixo de classe da animação de entrada: "" quando não anima (conteúdo já visível),
// " is-animated" esperando e " is-animated is-visible" depois que o bloco aparece. Os estados ficam no CSS.
export function useInView<T extends Element>(threshold = 0.2) {
  const ref = useRef<T>(null);
  const [animate] = useState(canAnimate);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!animate || !el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        setVisible(true);
        io.disconnect();
      },
      { threshold }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [animate, threshold]);

  return [ref, animate ? ` is-animated${visible ? " is-visible" : ""}` : ""] as const;
}
